module.exports = __webpack_public_path__ + "static/assets/7b7bd52dc5bb9a9c4ff9bdc2861ad87c.ttf";